'use strict';

const config = require('./config');

function safeErrorLogging(msg) {
    if (typeof console !== 'undefined' && typeof console.error !== 'undefined') { // eslint-disable-line no-console
        if (typeof msg === 'string') {
            console.error(msg); // eslint-disable-line no-console
            return;
        }
        console.error(JSON.stringify(msg)); // eslint-disable-line no-console
    }
}

const trackEvent = (metric, eventName = null, dimensions = {}) => {
    const eventData = JSON.parse(JSON.stringify(dimensions)); // IE-compatible copy object without polyfill
    eventData.metric = metric;
    eventData.eventName = eventName;
    const eventPayload = JSON.stringify(eventData);

    const remoteUrl = `${config.apiUrl}${config.testMode ? '/?dryRun=true' : ''}`;
    // if it's IE9
    if (typeof XDomainRequest !== 'undefined' && typeof window.atob !== 'function') {
        const xdr = new window.XDomainRequest();
        xdr.onload = function() {
            if (xdr.status < 200 || xdr.status >= 400) { // eslint-disable-line no-magic-numbers
                safeErrorLogging(`status: ${xdr.status}, responseText: ${xdr.responseText}`);
            }
        };
        xdr.onerror = safeErrorLogging;
        xdr.onprogress = function() {};
        xdr.open('POST', remoteUrl);
        xdr.send(eventPayload);
    } else {
        const xhr = new XMLHttpRequest();
        xhr.open('POST', remoteUrl);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = function() {
            if (xhr.status < 200 || xhr.status >= 400) { // eslint-disable-line no-magic-numbers
                safeErrorLogging(`status: ${xhr.status}, responseText: ${xhr.responseText}`);
            }
        };
        xhr.send(eventPayload);
    }
};

module.exports = trackEvent;
